'use client'

import {
  Form,
  Input,
  SubmitButton,
  Textarea,
  validateEmail,
} from '~/components/form'
import { Turnstile } from '~/components/turnstile'
import { combinedContactAction } from '~/integrations/mandrill'

export function ContactForm() {
  return (
    <Form
      action={combinedContactAction}
      className="relative dt:dr-w-378 flex flex-col dr-gap-8 text-[color:theme('colors.white')]"
    >
      <Input
        label="" // bad for accessibility
        type="text"
        id="name"
        placeholder="name_"
        required
        className="dots-pattern terminal font-[500] lowercase dr-h-44 dr-px-16 dr-py-12"
      />
      <Input
        label="" // bad for accessibility
        type="text"
        id="email"
        placeholder="e-mail_"
        required
        className="dots-pattern terminal font-[500] lowercase dr-h-44 dr-px-16 dr-py-12"
        validation={validateEmail}
      />
      <Input
        label="" // bad for accessibility
        type="text"
        id="subject"
        placeholder="subject_"
        required
        className="dots-pattern terminal font-[500] lowercase dr-h-44 dr-px-16 dr-py-12"
      />
      <Textarea
        label="" // bad for accessibility
        id="message"
        placeholder="message_"
        required
        className="dots-pattern terminal font-[500] lowercase dr-h-232 dr-px-16 dr-py-12"
      />
      <Turnstile />
      <SubmitButton
        className="cta dr-mt-8"
        textStates={{
          error: 'please try again',
          pending: 'sending_',
          success: 'sent_',
          message_received: 'message received_',
        }}
      >
        send_
      </SubmitButton>
    </Form>
  )
}
